module.exports = "/assets/data/09d081e29e670985d7e24e90d999ac29-CO1.data.json";